/* LP v2 wizard — the staged "eligibility" check and the reveal burst.
 *
 * window.AflWizLoader.run(root, cfg) → Promise
 *   Fills the in-box loader card (`[data-wiz-loader]`, shown by the wizard
 *   in place of the step — no overlay, owner 08.09): title, up to four lines
 *   that light up one after the other (an ldrs <l-ring-2> while active, a
 *   gold tick when done), a thin gold bar, a fine line, then the "Approved"
 *   stamp. Timing is randomised per run — each line waits cfg.ms × 0.85–1.6,
 *   the last line takes an extra "deliberation" pause — so the check never
 *   reads as a fixed timer (owner: "chậm hơn, random, kiểu check kỹ").
 *   Resolves ~0.9 s after the stamp so the caller swaps steps under a
 *   settled screen. Theatre by owner decision; copy lives in section settings.
 * window.AflWizLoader.burst(el)
 *   canvas-confetti flurry from an element (assets/afroyla-confetti.min.js),
 *   never on reduced motion. */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function wait(ms) {
    return new Promise(function (r) {
      setTimeout(r, reduced ? Math.min(ms, 150) : ms);
    });
  }

  function between(lo, hi) {
    return lo + Math.random() * (hi - lo);
  }

  function lineEl(text) {
    var li = document.createElement('li');
    li.className = 'afl-wiz__loader-line';
    var ico = document.createElement('span');
    ico.className = 'afl-wiz__loader-ico';
    var label = document.createElement('span');
    label.textContent = text;
    li.appendChild(ico);
    li.appendChild(label);
    return li;
  }

  function spinner() {
    // ldrs web component when the bundle registered it; a plain dot otherwise
    if (window.customElements && window.customElements.get('l-ring-2')) {
      var el = document.createElement('l-ring-2');
      el.setAttribute('size', '20');
      el.setAttribute('stroke', '2.5');
      el.setAttribute('speed', '0.8');
      el.setAttribute('color', '#030405');
      return el;
    }
    var dot = document.createElement('span');
    dot.textContent = '…';
    return dot;
  }

  function tick() {
    var t = document.createElement('span');
    t.className = 'afl-wiz__tick';
    return t;
  }

  function run(root, cfg) {
    var card = root.querySelector('[data-wiz-loader]');
    if (!card) return Promise.resolve();
    var title = card.querySelector('[data-wiz-loader-title]');
    var list = card.querySelector('[data-wiz-loader-lines]');
    var bar = card.querySelector('[data-wiz-loader-bar]');
    var fine = card.querySelector('[data-wiz-loader-fine]');
    var stamp = card.querySelector('[data-wiz-stamp]');
    var lines = (cfg.lines || []).filter(Boolean);
    var per = Math.max(300, cfg.ms || 1300);

    title.textContent = cfg.title || '';
    list.innerHTML = '';
    if (fine) {
      fine.textContent = cfg.fine || '';
      fine.hidden = !cfg.fine;
    }
    stamp.hidden = true;
    stamp.textContent = cfg.done || 'Approved';
    bar.style.width = '0%';
    card.classList.remove('is-done');
    var items = lines.map(function (t) {
      var li = lineEl(t);
      list.appendChild(li);
      return li;
    });
    card.hidden = false;

    var chain = wait(260);
    items.forEach(function (li, i) {
      var last = i === items.length - 1;
      chain = chain
        .then(function () {
          li.classList.add('is-active');
          li.querySelector('.afl-wiz__loader-ico').appendChild(spinner());
          // the bar creeps to just short of this line's share, then jumps on the tick
          bar.style.width = Math.round(((i + 0.55) / items.length) * 100) + '%';
          // randomised cadence; the last line "deliberates" longer before the verdict
          var ms = per * between(0.85, 1.6);
          if (last) ms += between(700, 1500);
          return wait(ms);
        })
        .then(function () {
          var ico = li.querySelector('.afl-wiz__loader-ico');
          ico.innerHTML = '';
          ico.appendChild(tick());
          li.classList.remove('is-active');
          li.classList.add('is-done');
          bar.style.width = Math.round(((i + 1) / items.length) * 100) + '%';
          return wait(between(220, 420));
        });
    });
    return chain
      .then(function () {
        bar.style.width = '100%';
        card.classList.add('is-done');
        stamp.hidden = false;
        return wait(900);
      })
      .then(function () {
        card.hidden = true;
      });
  }

  function burst(el) {
    if (reduced || typeof window.confetti !== 'function' || !el) return;
    var r = el.getBoundingClientRect();
    if (!r.width) return;
    window.confetti({
      particleCount: 46,
      spread: 64,
      startVelocity: 20,
      gravity: 1.05,
      decay: 0.9,
      ticks: 110,
      scalar: 0.7,
      shapes: ['square', 'circle'],
      colors: ['#a9894c', '#d8c48e', '#030405', '#ffffff'],
      origin: { x: (r.left + r.width / 2) / window.innerWidth, y: (r.top + Math.min(r.height, 120) / 2) / window.innerHeight },
      zIndex: 40,
      disableForReducedMotion: true,
    });
  }

  window.AflWizLoader = { run: run, burst: burst };
})();
